import React, { useState, useEffect, Suspense } from 'react';
import { ConsentManagementPlatform } from '@guardian/consent-management-platform/lib/ConsentManagementPlatform';
import { shouldShow, setErrorHandler, } from '@guardian/consent-management-platform';
export const CMP = () => {
    const [show, setShow] = useState(false);
    useEffect(() => {
        if (shouldShow()) {
            setShow(true);
            // setErrorHandler takes function to be called on errors in the CMP UI
            setErrorHandler((errMsg) => {
                const err = new Error(errMsg);
                window.guardian.modules.sentry.reportError(err, 'cmp');
            });
        }
    }, []);
    return (React.createElement(React.Fragment, null, show && (React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
        React.createElement(ConsentManagementPlatform, { source: "dcr", onClose: () => setShow(false) })))));
};
